import { cloneElement, isValidElement, type ReactElement, type JSXElementConstructor, type CSSProperties } from "react"
import anime from "./Animate.module.css"

export const AnimationTypes = {
  fadeIn: "fadeIn",
  fadeInTraslate: "fadeInTraslate",
  fadeOut: "fadeOut",
  slideUpIn: "slideUpIn",
  slideDownIn: "slideDownIn",
  slideRightIn: "slideRightIn",
  slideLeftIn: "slideLeftIn",
  zoomIn: "zoomIn",
  zoomOut: "zoomOut",
  scaleUp: "scaleUp",
  scaleDown: "scaleDown",
  rotateIn: "rotateIn",
} as const

type AnimationType = keyof typeof AnimationTypes

interface AnimateProps {
  type?: AnimationType
  duration?: string
  delay?: string
  children: ReactElement<{ className?: string; style?: CSSProperties }, string | JSXElementConstructor<any>>
}

export default function Animate({
  type = "fadeIn",
  duration = "1s",
  children,
  delay = "0s",
}: AnimateProps): ReactElement {
  if (!isValidElement(children)) {
    console.warn("Animate deve envolver apenas um elemento JSX válido.")

    return (<>{children}</>) as ReactElement
  }

  const existingClass = children.props.className ?? ""

  const existingStyle = children.props.style ?? {}

  const childWithAnimation = cloneElement(children, {
    className: `${existingClass} ${anime[type]}`.trim(),
    style: {
      ...existingStyle,
      animationDelay: delay,
      animationDuration: duration,
    } satisfies CSSProperties,
  })

  return childWithAnimation
}
